import { FocusEventHandler } from "react";
import { TextField } from "@material-ui/core";
import { OptionGroup } from "components/Styled";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  error?: boolean;
  helperText?: string;
}

export default function DescriptionField({
  value,
  onChange,
  onBlur,
  error = false,
  helperText,
}: Props) {
  const { t } = useTranslation("templateDefinitions");
  return (
    <OptionGroup>
      <TextField
        variant="outlined"
        name="description"
        label={t("form.description.label")}
        fullWidth
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        helperText={helperText}
        inputProps={{
          "data-testid": "template-description-input",
        }}
      />
    </OptionGroup>
  );
}
